import React, { createContext, useContext, useState } from 'react';

const FeatureDisabledContext = createContext();

export const useFeatureDisabled = () => {
  const context = useContext(FeatureDisabledContext);
  if (!context) {
    throw new Error('useFeatureDisabled must be used within a FeatureDisabledProvider');
  }
  return context;
};

export const FeatureDisabledProvider = ({ children }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const showFeatureDisabledModal = () => {
    setIsModalOpen(true);
  };

  const hideFeatureDisabledModal = () => {
    setIsModalOpen(false);
  };

  return (
    <FeatureDisabledContext.Provider value={{
      isModalOpen,
      showFeatureDisabledModal,
      hideFeatureDisabledModal
    }}>
      {children}
    </FeatureDisabledContext.Provider>
  );
};